import React from 'react'
import { Edit, useForm } from '@refinedev/antd'
import { Form, Input, Divider } from 'antd'
import type { Tables } from '@muaa/shared'
import { bodyValueProps, normalizeBody } from './create'

type Devotional = Tables<'devotionals'>

export function DevotionalEdit() {
  const { formProps, saveButtonProps } = useForm<Devotional>()

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        {/* ── Header ─────────────────────────────────────────── */}
        <Divider orientation="left">Header</Divider>
        <Form.Item label="Date" name="date" rules={[{ required: true, message: 'Date is required' }]}>
          <Input placeholder='e.g. "Saturday Morning" or 2025-06-01' />
        </Form.Item>
        <Form.Item label="Title" name="title" rules={[{ required: true, message: 'Title is required' }]}>
          <Input placeholder="Devotional title" />
        </Form.Item>

        {/* ── Scripture ──────────────────────────────────────── */}
        <Divider orientation="left">Scripture</Divider>
        <Form.Item label="Reference" name="ref" rules={[{ required: true, message: 'Reference is required' }]}>
          <Input placeholder="e.g. Jeremiah 29:11" />
        </Form.Item>
        <Form.Item label="Verse" name="verse" rules={[{ required: true, message: 'Verse is required' }]}>
          <Input.TextArea rows={4} placeholder="Full scripture verse text" />
        </Form.Item>

        {/* ── Reflection ─────────────────────────────────────── */}
        <Divider orientation="left">Reflection</Divider>
        <Form.Item
          label="Body"
          name="body"
          rules={[{ required: true, message: 'Body is required' }]}
          getValueProps={bodyValueProps}
          normalize={normalizeBody}
        >
          <Input.TextArea
            rows={10}
            placeholder="One paragraph per line. Each line becomes an element in the body array."
          />
        </Form.Item>

        {/* ── Prayer ─────────────────────────────────────────── */}
        <Divider orientation="left">Prayer</Divider>
        <Form.Item label="Prayer" name="prayer" rules={[{ required: true, message: 'Prayer is required' }]}>
          <Input.TextArea rows={4} placeholder="Closing prayer text" />
        </Form.Item>
      </Form>
    </Edit>
  )
}
